import { render, staticRenderFns } from "./PopupAgentCommentAdd.vue?vue&type=template&id=45388389&scoped=true&lang=pug&"
import script from "./PopupAgentCommentAdd.vue?vue&type=script&lang=coffee&"
export * from "./PopupAgentCommentAdd.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupAgentCommentAdd.vue?vue&type=style&index=0&id=45388389&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45388389",
  null
  
)

export default component.exports